import type { ContentHref } from '@generalTypes/apiTypes';
import type { RootState } from '@generalTypes/rootStateTypes';
import { selectWebPage } from '@newStore/documentApi/documentApiSelectors';
import { useSelector } from 'react-redux';

export const useCurrentWebConfig = () => {
  return useSelector((state: RootState) =>
    selectWebPage(state, state.documentUI.currentEditingNode as ContentHref),
  );
};
